<script>
	import { page } from '$app/stores';
	import { signedInUser } from '@ctm/auth/store';

	window.beamer_config = {
		product_id: 'ODSfhuQO53008', //DO NOT CHANGE: This is your product code on Beamer

		bounce: false,
		top: 20,
		right: 12,

		user_firstname: $signedInUser.firstName,
		user_lastname: $signedInUser.lastName,
		user_email: $signedInUser.email,
	};
</script>

<svelte:head>
	{#if !['/sso', '/risk-hub'].includes($page?.url.pathname)}
		<script type="text/javascript" src="https://app.getbeamer.com/js/beamer-embed.js" defer></script>
	{/if}
</svelte:head>
